/*
 * @Author: wangwei18
 * @Date: 2025-03-04 16:02:37
 * @LastEditors: wangwei18
 * @LastEditTime: 2025-03-05 10:59:33
 * @Description:
 */
import { Icon } from '@docs/kd-d2c-components';
import intl from '@/internationalzation/intl';
import { thinking_process_arrow } from '@src/assets/icons';
import classNames from 'classnames';
import { useState } from 'react';
import './index.less';
interface Props {
  title: string;
  defaultExpend?: boolean;
  children?: React.ReactNode[];
  icon?: string;
}
const BlockCollapse = ({
  title,
  defaultExpend = false,
  children,
  icon = '',
}: Props) => {
  const [isExpend, setIsExpend] = useState(defaultExpend);
  return (
    <div className="block-collapse">
      <div
        className="block-collapse-bar"
        onClick={() => setIsExpend(!isExpend)}
      >
        <img src={icon} alt="icon" />
        <div className="block-collapse-title">{title}</div>
        <Icon
          size={14}
          className={classNames({
            rotate180: !isExpend,
          })}
          icon={thinking_process_arrow}
        />
      </div>
      {isExpend ? (
        <div className="block-collapse-content">{children}</div>
      ) : null}
    </div>
  );
};
export default BlockCollapse;
export const Demo = () => {
  return (
    <div
      style={{
        padding: 40,
        display: 'flex',
        gap: 12,
        flexDirection: 'column',
        maxWidth: 400,
      }}
    >
      <BlockCollapse title={intl.t('解析RSS内容')} defaultExpend={true}>
        <div>123</div>
        <div>123</div>
      </BlockCollapse>
    </div>
  );
};
